import './styles.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { QueryCache, QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

import { toast } from 'sonner';

import { apiErrorMessage } from '@/lib/clients';

import { routeTree } from './routeTree.gen';

const queryClient = new QueryClient({
  // Toute lecture en échec est signalée ; un seul toast (id fixe) même si plusieurs requêtes échouent ensemble
  queryCache: new QueryCache({
    onError: (err) => toast.error(`Erreur de chargement : ${apiErrorMessage(err, 'serveur injoignable')}`, { id: 'query-error' }),
  }),
  defaultOptions: {
    queries: { staleTime: 30_000, gcTime: 5 * 60_000, retry: 1 },
  },
});

const persister = createSyncStoragePersister({ storage: window.localStorage });

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
      <RouterProvider router={router} />
    </PersistQueryClientProvider>
  </StrictMode>,
);
